type Props = { message?: string }
export function ErrorMessage({ message }: Props) {
  return message ? <span className="text-base text-red-600">{message}</span> : null
}
